module.exports = __webpack_public_path__ + "img/cross-error-shop.8ec4be96.svg";